import { splitNumber } from "../../features/splitNumber/splitNumber";
import { useCompare } from "./../../context/CompareContext";

interface CompareProductsProps {
    id: number;
    name: string;
    primary_image: string;
    quantity_check: { price?: number } | null;
    slug: string;
    has_variation?: any,
    count?: any,
    price?: any,
}

const CompareProducts = ({
    name,
    primary_image,
    quantity_check,
    slug,
    has_variation,
    count,
    price
}: CompareProductsProps) => {
    const { selectedSlugs, addSlug, removeSlug } = useCompare();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.stopPropagation();
        if (selectedSlugs.includes(slug)) {
            removeSlug(slug);
        } else {
            const added = addSlug(slug);
            if (!added) {
                alert("حداکثر ۳ محصول می‌توانید انتخاب کنید!");
            }
        }
    };

    const onCardClick = () => {
        if (selectedSlugs.includes(slug)) {
            removeSlug(slug);
        } else {
            const added = addSlug(slug);
            if (!added) {
                alert("حداکثر ۳ محصول می‌توانید انتخاب کنید!");
            }
        }
    };

    return (
        <>
            <div
                className="card new-product-card border-1 rounded rounded-4"
                onClick={onCardClick}
                style={{ cursor: "pointer" }}
            >
                <div className="d-flex justify-content-center mt-1">
                    <input
                        className="form-check-input border-1 border-black"
                        type="checkbox"
                        checked={selectedSlugs.includes(slug)}
                        onChange={handleChange}
                    />
                </div>
                <div className="rounded rounded-4 p-3 pt-0">
                    <div className="d-flex justify-content-center align-items-center">
                        <img src={primary_image} alt="product" />
                    </div>
                </div>
                <div className="card-body mt-1">
                    <div
                        className="d-flex justify-content-between align-items-center"
                        style={{ height: "40px" }}
                    >
                        <span className="text-dark w-100 text-line font-medium-lg mb-0">
                            {name}
                        </span>
                    </div>
                    <hr />
                    <div className="d-flex align-items-center justify-content-between">
                        <button
                            className="btn btn-primary py-1"
                            onClick={(e) => {
                                e.stopPropagation();
                            }}
                        >
                            خرید
                        </button>
                        {has_variation !== 0 ? (
                            <>
                                {quantity_check?.price ? (
                                    <span className="card-title price font-medium-lg fw-bold mt-3">{splitNumber(quantity_check?.price)}  تومان</span>
                                ) : (
                                    <span className="card-title text-danger fw-bold price font-medium-lg mt-3">نا موجود</span>
                                )}
                            </>
                        )
                            :
                            (
                                <>
                                    {count !== 0 ? (
                                        <span className="card-title price fw-bold font-medium-lg mt-3">{splitNumber(price)}  تومان</span>
                                    ) : (
                                        <span className="card-title text-danger fw-bold price font-medium-lg mt-3">نا موجود</span>
                                    )}
                                </>
                            )
                        }
                    </div>
                </div>
            </div>
        </>
    );
};

export default CompareProducts;